import React from 'react';
import { useIntl } from 'react-intl';
import { Box, CircularProgress, Typography } from '@mui/material';
import WidgetBox from '../../../Components/Paper/WidgetBox';
import ProgressBar from '../../../Components/LinearProgress';
import EmptyInfiniteListComponent from '../../../Components/ContactListWrapper/EmptyInfiniteListComponent';
import { formatThousands } from '../../../Utils/constants/general';
import { OUTCOME_COLORS } from '../../MassiveMessages/Utils/constants';

//funnel: each step is compared with the previous one
const getKpis = ({ total, sent, opened, interactions }) => [
  { label: 'SENDED', value: sent, base: total, color: OUTCOME_COLORS.SENT },
  {
    label: 'OPENED',
    value: opened,
    base: sent,
    color: OUTCOME_COLORS.POSITIVE,
  },
  {
    label: 'CTA_INTERACTIONS',
    value: interactions,
    base: opened,
    color: OUTCOME_COLORS.CTA,
  },
];

const SendsSummary = function SendsSummary({ stats = null }) {
  const intl = useIntl();

  const renderContent = () => {
    if (!stats)
      return (
        <Box sx={{ display: 'flex', flexGrow: 1, placeContent: 'center' }}>
          <CircularProgress sx={{ alignSelf: 'center' }} />
        </Box>
      );
    if (!stats.summary) return <EmptyInfiniteListComponent />;

    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-evenly',
          gap: '16px',
          flexGrow: 1,
          p: '16px 24px',
          overflow: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {intl.messages.TOTAL}
          </Typography>
          <Typography sx={{ fontSize: '1.75rem', fontWeight: 500 }}>
            {formatThousands(stats.summary.total)}
          </Typography>
        </Box>
        {getKpis(stats.summary).map(({ label, value, base, color }) => (
          <Box
            key={label}
            sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline',
              }}
            >
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {intl.messages[label]}
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {`${formatThousands(value)} / ${formatThousands(base)}`}
              </Typography>
            </Box>
            <ProgressBar
              value={value}
              total={base}
              size="large"
              color={color}
              hideLabel
              showPercentageInside
            />
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <WidgetBox
      flex="1 1 auto"
      height="50%"
      title={intl.messages.SUMMARY}
      widget={renderContent()}
    />
  );
};

export default SendsSummary;
